import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import ProfileGold from '../../../svg/ProfileGold.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';

class YourDetails extends Component {
  state = {
    client: {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: ''
    },
    formIsInvalid: false, // indicate to input fields to show errors if they have any
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const {
      first_name = '',
      last_name = '',
      email = '',
      phone_number = ''
    } = this.state.client;

    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Your Details"
          icon={<ProfileGold className="onboarding-new__icon--top" />}
          isHeadlineOnTop={false}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="first_name"
                placeholder="First Name"
                value={first_name}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="last_name"
                placeholder="Last Name"
                value={last_name}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="email"
                placeholder="Email"
                value={email}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                validations="isEmail"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="phone_number"
                placeholder="Phone"
                value={phone_number}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                validations={{
                  customValidation: function(values, value) {
                    // remove dashes
                    const justNumbers = value.split('-').join('');
                    if (value[0] === '1') {
                      // if 1 prefix included phone number should be 11 chars (e.g. '12223334444')
                      return justNumbers.length === 11;
                    } else {
                      //otherwise 10 chars (e.g. '2223334444')
                      return justNumbers.length === 10;
                    }
                  }
                }}
                required
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;

    this.setState({ client: { ...this.state.client, [name]: value } });
  };

  handleClientUpdate = () => {
    const { client } = this.state;
    this.props.updateClient(client);
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default YourDetails;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/YourDetails.js